import { GET_USER_PERMISSIONS } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import type { IHubUserPermissionsResponse } from "@models";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export const USER_PERMISSIONS_KEY = "userPermissionsKey";

export const getUserPermissionsKey = (basePath?: string) =>
  [USER_PERMISSIONS_KEY, basePath] as const;

export const useUserPermissions = (
  basePath?: string,
  options?: Partial<
    UseQueryOptions<
      IHubUserPermissionsResponse,
      AxiosError,
      IHubUserPermissionsResponse,
      ReturnType<typeof getUserPermissionsKey>
    >
  >,
) => {
  return useQuery({
    queryKey: getUserPermissionsKey(basePath),
    queryFn: async () => {
      const url = basePath
        ? `${basePath.replace(/\/$/, "")}${GET_USER_PERMISSIONS}`
        : GET_USER_PERMISSIONS;
      const data = await mutationFetch<IHubUserPermissionsResponse>({
        url,
        method: "GET",
      });
      return data;
    },
    ...options,
  });
};
